if (!customElements.get('hircan-certificates')) {
  customElements.define('hircan-certificates', class extends HTMLElement {
    connectedCallback() {
      if (this.events) return;
      this.dialog = this.querySelector('[data-certificates-dialog]');
      this.image = this.querySelector('[data-certificates-viewer-image]');
      this.viewerTitle = this.querySelector('[data-certificates-viewer-title]');
      this.originalLink = this.querySelector('[data-certificates-viewer-original]');
      this.zoomButton = this.querySelector('[data-certificates-zoom]');
      this.errorMessage = this.querySelector('[data-certificates-error]');
      this.reader = this.querySelector('[data-certificates-reader]');
      if (!this.dialog || !this.image || typeof this.dialog.showModal !== 'function') return;
      this.events = new AbortController();
      const options = { signal:this.events.signal };
      this.addEventListener('click', event => this.onClick(event), options);
      this.dialog.addEventListener('close', () => this.onClose(), options);
      this.image.addEventListener('load', () => { this.zoomButton.disabled = false; }, options);
      this.image.addEventListener('error', () => {
        if (!this.dialog.open) return;
        this.image.hidden = true;
        this.errorMessage.hidden = false;
        this.zoomButton.disabled = true;
      }, options);
    }

    disconnectedCallback() {
      if (this.dialog?.open) this.dialog.close();
      this.events?.abort();
      this.events = null;
      this.opener = null;
      this.image?.removeAttribute('src');
    }

    onClick(event) {
      const closeButton = event.target.closest('[data-certificates-close]');
      if (closeButton && this.contains(closeButton)) {
        this.dialog.close();
        return;
      }
      const zoomButton = event.target.closest('[data-certificates-zoom]');
      if (zoomButton && this.contains(zoomButton)) {
        const zoomed = this.dialog.classList.toggle('is-zoomed');
        this.zoomButton.setAttribute('aria-pressed', String(zoomed));
        this.zoomButton.textContent = zoomed ? this.zoomButton.dataset.zoomOut : this.zoomButton.dataset.zoomIn;
        this.reader.scrollTop = 0;
        this.reader.scrollLeft = 0;
        return;
      }
      if (event.target === this.dialog) {
        const bounds = this.dialog.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) this.dialog.close();
        return;
      }
      const opener = event.target.closest('[data-certificates-open]');
      if (!opener || !this.contains(opener) || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      let url;
      try { url = new URL(opener.href, this.ownerDocument.baseURI); } catch { return; }
      if (!['http:', 'https:'].includes(url.protocol)) return;
      event.preventDefault();
      this.opener = opener;
      this.viewerTitle.textContent = opener.dataset.documentTitle || '';
      this.originalLink.href = url.href;
      this.image.alt = opener.dataset.documentAlt || opener.dataset.documentTitle || '';
      this.image.hidden = false;
      this.errorMessage.hidden = true;
      this.dialog.classList.remove('is-zoomed');
      this.zoomButton.disabled = true;
      this.zoomButton.setAttribute('aria-pressed', 'false');
      this.zoomButton.textContent = this.zoomButton.dataset.zoomIn;
      this.image.src = url.href;
      if (!this.dialog.open) this.dialog.showModal();
      this.reader.scrollTop = 0;
      this.reader.scrollLeft = 0;
      this.querySelector('[data-certificates-close]').focus();
    }

    onClose() {
      this.dialog.classList.remove('is-zoomed');
      this.image.hidden = true;
      this.image.removeAttribute('src');
      this.errorMessage.hidden = true;
      this.zoomButton.setAttribute('aria-pressed', 'false');
      this.zoomButton.textContent = this.zoomButton.dataset.zoomIn;
      if (this.opener?.isConnected) this.opener.focus({ preventScroll:true });
      this.opener = null;
    }
  });
}
